import { Component } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { SidebarSplitViewKey } from '@modules/common/types/sidebar-split-view-key';

@Component({
  selector: 'app-events-layout',
  templateUrl: './events-layout.component.html',
  styleUrls: ['./events-layout.component.less', '../../styles.less'],
  standalone: false,
})
export class EventsLayoutComponent {
  protected readonly sidebarSplitViewKey = SidebarSplitViewKey;
  protected readonly app = Application.calendar;
}
